import Vue from 'vue'
import VuePageStack from 'vue-page-stack';
import router from '../router'

Vue.use(VuePageStack, { router })
